import { debounce } from 'lodash';

export default {
  data() {
    return {
      hoverRemoveButton: {
        target: null,
        hideHoverRemoveButtonTooltipDebounce: debounce(() => {
          this.hoverRemoveButton.target = null;
        }, 200),
      },
    };
  },
  methods: {
    showHoverRemoveButtonTooltip(target) {
      this.hoverRemoveButton.hideHoverRemoveButtonTooltipDebounce.cancel();
      if (this.hoverRemoveButton.target !== target) {
        this.hoverRemoveButton.target = null;
        this.$nextTick(() => {
          this.hoverRemoveButton.target = target;
        });
      }
    },
    hideHoverRemoveButtonTooltip() {
      this.hoverRemoveButton.hideHoverRemoveButtonTooltipDebounce();
    },
  },
};
